import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import useGetFile from 'middleware/hcp/files/useGetFile';
import useGetNightlyReport from 'middleware/hcp/reports/useGetNightlyReport';

const DownloadOriginal = ({ recordingId }: { recordingId?: string }) => {
  const { t } = useTranslation();
  const { recording } = useParams();
  const recordingParam = recording ?? recordingId;
  const { reportsList, reportsLoading } = useGetNightlyReport(
    recordingParam ? [recordingParam] : [],
    true
  );
  const { file, fileLoading } = useGetFile(reportsList?.length ? reportsList?.[0]?.file : '');
  return (
    <a href={file} target="_blank" rel="noreferrer" data-testid="nightn-download-original-link">
      <Button
        disabled={fileLoading || reportsLoading}
        size="middle"
        id="download-original"
        icon={<DownloadOutlined />}
        data-testid="nightn-download-original-btn"
        type="primary">
        {t('download-original-report')}
      </Button>
    </a>
  );
};

export default DownloadOriginal;
